import { env } from "configs/EnvironmentConfig";
import { checkHaveToken } from "constants/actionAccess";
import fetchV2 from "../auth/FetchInterceptorV2";

const notificationService = {};

// List Management Notification
notificationService.listManagementNotification = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  return fetchV2({
    url: `${env.API_MSP}/notifications/my`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "caseDocsign",
    },
  });
};

// List Notification
notificationService.listPopupNotification = () => {
  if(!checkHaveToken()){
    return false
  }
  return fetchV2({
    url: `${env.API_MSP}/notifications/my`,
    method: "get",
    params: {
      "filter[auth_status]": "M",
      "per-page": 5,
      sort: "-maker_date",
    },
  });
};

notificationService.markReadNotification = notificationId => {
  return fetchV2({
    url: `${env.API_MSP}/notifications/${notificationId}/read`,
    method: "post",
  });
};

notificationService.markReadAllNotification = () => {
  return fetchV2({
    url: `${env.API_MSP}/notifications/read-all`,
    method: "get",
  });
};

notificationService.uploadDeviceToken = data => {
  return fetchV2({
    url: `${env.API_MSP}/my/device-token`,
    method: "post",
    data: {
      ...data,
    },
  });
};

notificationService.removeDeviceToken = data => {
  return fetchV2({
    url: `${env.API_MSP}/my/remove-device-token`,
    method: "post",
    data: {
      ...data,
    },
  });
};

export default notificationService;
